import React, { useEffect, useState } from 'react';
import { useStyletron } from 'baseui';
import { LoadingSpinner } from 'baseui/button/styled-components';
import { ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { Slider } from 'baseui/slider';
import { Spinner } from 'baseui/spinner';
import { Textarea } from 'baseui/textarea';
import { HeadingSmall } from 'baseui/typography';
import { createReportQAConfig, getReportQAConfig, runReportQA } from '@gtintel/platform-api';
import { useReportQAContext } from '../../../context';
const ConfigModalContent = () => {
  const [css] = useStyletron();
  const [, mutate, query] = useReportQAContext();
  const {
    configButtonLoading,
    runButtonLoading,
    selectedProject,
    selectedReportId
  } = query(state => ({
    configButtonLoading: state.modal.configButtonLoading,
    runButtonLoading: state.modal.runButtonLoading,
    selectedProject: state.selectedProject,
    selectedReportId: state.modal.selectedReportId
  }));
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState({
    prompt: '',
    max_tokens: 4000,
    temperature: 0.0,
    top_p: 1.0
  });
  useEffect(() => {
    setLoading(true);
    getReportQAConfig().then(response => {
      setConfig(response.results[0].config);
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  if (loading) return <Spinner />;
  return <>
      <ModalHeader>Report QA - Configuration</ModalHeader>
      <ModalBody>
        <div className={css({
        maxHeight: '60vh',
        overflow: 'scroll'
      })}>
          <HeadingSmall>Prompt</HeadingSmall>
          <Textarea value={config.prompt} onChange={e => {
          setConfig({
            ...config,
            prompt: e.currentTarget.value
          });
        }} overrides={{
          Input: {
            style: {
              minHeight: '200px'
            }
          }
        }} />
          <HeadingSmall>Max Tokens</HeadingSmall>
          <Slider max={10000} min={1000} onChange={({
          value
        }) => {
          setConfig({
            ...config,
            max_tokens: value[0]
          });
        }} step={100} value={[config.max_tokens]} />
          <HeadingSmall>Temperature</HeadingSmall>
          <Slider max={1.0} min={0} onChange={({
          value
        }) => {
          setConfig({
            ...config,
            temperature: value[0]
          });
        }} step={0.1} value={[config.temperature]} />
          <HeadingSmall>Top P</HeadingSmall>
          <Slider max={1.0} min={0} onChange={({
          value
        }) => {
          setConfig({
            ...config,
            top_p: value[0]
          });
        }} step={0.1} value={[config.top_p]} />
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalButton onClick={() => {
        mutate(state => ({
          ...state,
          modal: {
            ...state.modal,
            configButtonLoading: true
          }
        }));
        createReportQAConfig(config).finally(() => {
          mutate(state => ({
            ...state,
            modal: {
              ...state.modal,
              configButtonLoading: false
            }
          }));
        });
      }}>
          {configButtonLoading ? <LoadingSpinner /> : 'Save Configuration'}
        </ModalButton>
        <ModalButton onClick={() => {
        mutate(state => ({
          ...state,
          modal: {
            ...state.modal,
            runButtonLoading: true
          }
        }));
        runReportQA(selectedProject.id, selectedReportId, config.prompt, config.max_tokens, config.temperature, config.top_p).then(response => {
          mutate(state => ({
            ...state,
            modal: {
              ...state.modal,
              content: 'results',
              result: response
            }
          }));
        }).finally(() => {
          mutate(state => ({
            ...state,
            modal: {
              ...state.modal,
              runButtonLoading: false
            }
          }));
        });
      }}>
          {runButtonLoading ? <LoadingSpinner /> : 'Begin Analysis'}
        </ModalButton>
        {selectedProject.reports.length > 1 && <ModalButton className={css({
        float: 'left'
      })} onClick={() => {
        mutate(state => ({
          ...state,
          modal: {
            ...state.modal,
            content: 'reports'
          }
        }));
      }}>
            Back
          </ModalButton>}
      </ModalFooter>
    </>;
};
export default ConfigModalContent;